
export const s3Config = {
    bucketName:  "data-science-resources-educobot",
    dirName: "user-uploaded-data",    
    region: "ap-south-1",
    accessKeyId: "AKIATV35CQSBFYBN5L5U",
    secretAccessKey: "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",
}   